export type BookingStatus =
  | 'AVAILABLE'
  | 'BOOKED'
  | 'BOOKING_AMENDED'
  | 'CANCELLED'
  | 'CANCEL_FAILED'
  | 'TO_BE_CANCELLED'
  | 'FAILED'
  | 'PAY_ON_THE_DAY'
  | 'TO_BE_CONFIRMED'
  | 'UNAVAILABLE'
  | 'VOID'
  | 'OUTSTANDING'
  | 'NO_RESERVATION_REQUIRED'
  | 'ON_REQUEST'
  | 'OWN_ARRANGEMENTS'
  | 'ORIGIN_BLOCKOUT'
  | 'AWAITING_RELEASE';

export type PaymentStatus = 'INTERRAIL' | 'PREPAY' | 'POSTPAY';

export type PaymentType = 'deposit' | 'full_amount';

export const PERCENT_DEPOSIT = 20;

export type PriceTier = 'BUDGET' | 'MIDPRICE' | 'EXPENSIVE';

type CountryOfResidence = {
  countryId: string;
  countryName: string;
  cmsId: string | null;
};

export type Traveller = {
  age: number;
  firstname: string;
  lastname: string;
  title: string;
};

export type TravellerMix = {
  adultCount: number;
  childAges: number[];
  numberOfRooms: number;
};

export type BookingInformation = {
  bookingStatus: BookingStatus | null;
  bookedAt: string | null;
  customerDetails?: {
    customerEmail: string | null;
    customerFullname: string | null;
    customerPhone: string | null;
    countryOfResidence: CountryOfResidence | null;
  };
  travellerMix?: TravellerMix | null;
  travellerMixes?: TravellerMix[] | null;
  travellers?: Traveller[];
};

export type Charges = {
  amount: Payment;
  description: string;
  markupPercentage: number | null;
};

export type Payment = {
  currencyId: string;
  value: number | null;
};
